import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKnmDataViolation } from '../interfaces/IKnmDataViolation';

export async function fetchKnmViolations(id: number): Promise<IKnmDataViolation[]> {
  return apiGet<IKnmDataViolation[]>(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/violations/${id}`);
}
